import { createTheme } from '@abyss/web/tools/theme';

export const theme = createTheme('uhc', {
  deprecatedOptumIcons: true,
  theme: {
    fonts: {
      UHC_PRIMARY: 'AbyssEnterpriseSansVF, Arial, sans-serif',
      UHC_HEADING: 'UHCSerif, Georgia Bold, serif',
    },
    colors: {
      primary: '#196ECF',
      secondary: '#002677',
      warning: '#DB9C00',
      tertiary: '#E5F8FB',

      // UHC Palette
      UHC_BLUE: '#002677',
      UHC_WHITE: '#FFFFFF',
      UHC_BRIGHT_BLUE: '#00BED5',
      UHC_GOLD: '#F5B700',
      UHC_ORANGE: '#FF681F',
      UHC_CTA_BLUE: '#196ECF',
      UHC_CTA_ORANGE: '#D14600',
      UHC_CTA_DARK_ORANGE: '#AA3600',
      UHC_BRIGHT_BLUE_10: '#E5F8FB',
      UHC_BRIGHT_BLUE_20: '#CCF2F7',
      UHC_BRIGHT_BLUE_40: '#99E5EE',
      UHC_GRAY_DARK: '#333333',
      UHC_GRAY_MEDIUM: '#DADBDC',
      UHC_GRAY_LIGHT: '#F4F4F4',
    },
  },
});
